import type { EnterpriseDashboardFilters } from "../hooks/useEnterpriseDashboard";

export function dashboardPeriodSearchParams(
  filters: Pick<EnterpriseDashboardFilters, "dateFrom" | "dateTo" | "hospitalId">,
): URLSearchParams {
  const params = new URLSearchParams();
  if (filters.dateFrom) params.set("date_start", filters.dateFrom);
  if (filters.dateTo) params.set("date_end", filters.dateTo);
  if (filters.hospitalId) params.set("hospital_id", filters.hospitalId);
  return params;
}

export function dashboardPeriodQueryString(
  filters: Pick<EnterpriseDashboardFilters, "dateFrom" | "dateTo" | "hospitalId">,
): string {
  return dashboardPeriodSearchParams(filters).toString();
}

export function parseDashboardPeriodSearchParams(
  params: URLSearchParams,
): EnterpriseDashboardFilters {
  return {
    dateFrom: params.get("date_start") ?? "",
    dateTo: params.get("date_end") ?? "",
    hospitalId: params.get("hospital_id") ?? "",
  };
}

export function enterpriseDashboardPathWithPeriod(
  filters: Pick<EnterpriseDashboardFilters, "dateFrom" | "dateTo" | "hospitalId">,
): string {
  const qs = dashboardPeriodQueryString(filters);
  return qs ? `/dashboard/enterprise?${qs}` : "/dashboard/enterprise";
}
